import type { AllRouteEndpoints } from "../routeTypes";

export const knowledgeSourceDefinitionId = "/:app_group_id/knowledge_source/definition/:id";

export const knowledgeSourceDefinitionIdCacheKeys: AllRouteEndpoints[] = [
  "/:app_group_id/knowledge_source/definition/:id",
  "/:app_group_id/knowledge_source/definitions",
];
